import type { OTPInputProps, SlotProps } from "input-otp";
import { OTPInput } from "input-otp";
import { twMerge } from "tailwind-merge";

import InputErrorMessage from "./InputErrorMessage";

function Slot(props: Readonly<SlotProps>) {
  return (
    <div
      data-slot="otp-slot"
      className={twMerge(
        `bg-secondary text-text-primary group-data-[invalid=true]/otp-container:border-danger group-data-[invalid=true]/otp-container:text-danger relative flex h-14 w-10 items-center justify-center rounded-md border border-transparent font-medium transition-all duration-300`,
        props.char !== null && "border-border",
        props.isActive && "border-border-otp-active shadow-tabs",
      )}
    >
      <div
        className={`group-has-[input[data-input-otp-placeholder-shown]]/otp:opacity-20`}
      >
        {props.char ?? props.placeholderChar}
      </div>
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  );
}

function FakeCaret() {
  return (
    <div
      className={`pointer-events-none absolute inset-0 flex items-center justify-center`}
    >
      <div className="h-8 w-px bg-white" />
    </div>
  );
}

type OtpProps = Omit<
  OTPInputProps,
  "maxLength" | "render" | "containerClassName" | "children"
> & {
  isInvalid?: boolean;
  errorMessage?: string | null;
  ref?: React.Ref<HTMLInputElement>;
};

export default function Otp({
  isInvalid,
  errorMessage,
  ref,
  ...props
}: Readonly<OtpProps>) {
  return (
    <div
      className="group/otp-container space-y-4"
      data-invalid={isInvalid ? true : undefined}
    >
      <OTPInput
        ref={ref}
        containerClassName="group/otp flex gap-6 items-center has-[:disabled]:opacity-30 relative"
        render={({ slots }) => (
          <>
            {slots.map((slot, idx) => (
              // oxlint-disable-next-line react/no-array-index-key
              <Slot key={idx} {...slot} />
            ))}
          </>
        )}
        maxLength={6}
        {...props}
      />

      {errorMessage && <InputErrorMessage>{errorMessage}</InputErrorMessage>}
    </div>
  );
}
